import React from 'react';
import { useParams } from 'react-router-dom';
import ParlamentarService from '../../services/ParlamentarService';
import Main from '../main/Main';
import { Grid, Paper } from '@mui/material';
import useStyles from '../../components/layout/Styles';
import { IParlamentar } from '../../models/Parlamentar.Model';
import ParlamentarCarouselTabs from './_components/ParlamentarCarouselTabs'
// import _ from 'lodash';
import ParlamentarConsultaHeader from './_components/ParlamentarConsultaHeader';
import { ParlamentarConsultaBotoes } from './_components/ParlamentarConsultaBotoes';
import { ParlamentarConsultaInicio } from './_components/ParlamentarConsultaInicio';
import { ParlamentarConsultaAbas } from './_components/ParlamentarConsultaAbas';
import { useQuery } from '../../utils/utils';
import { useAuthorization } from "../../contexts/AuthorizationContext";

export default function ParlamentarConsulta(): JSX.Element {

    const { id } = useParams();
    const classes = useStyles();
    const [parlamentar, setParlamentar] = React.useState<IParlamentar>()
    const qry = useQuery().get('filtro');
    const { user } = useAuthorization();
    const [statusProcessamentoIA, setStatusProcessamentoIA] = React.useState(false);


    React.useEffect(() => {
        loadParlamentar()
        // eslint-disable-next-line
    }, [id])

    const loadParlamentar = () => {
        if (id)
            ParlamentarService
                .Get(Number(id))
                .then(parlamentar => {
                    setParlamentar(parlamentar)
                });
    }

    const intervalStatusProcessamentoIA = async () => {
        // alert('cheguei intervalStatusProcessamentoIA')
        const interval = setInterval(() => {
            ParlamentarService.GetStatusProcessamentoIA(Number(parlamentar.id))
                .then(res => {
                    setStatusProcessamentoIA(res?.data?.processamento_ia);
                    // Se o status for false, para o intervalo
                    if (res?.data?.processamento_ia === false) {
                        clearInterval(interval);
                    }
                })
                .catch(err => console.error(err));
        }, 2000); // 5 segundos
        return () => clearInterval(interval);
    };

    return (
        <div className={classes.root}>
            <Main>
                <Grid container justifyContent="space-around">

                    {/* ref={divRef} */}
                    <Paper style={{ borderRadius: "7px", width: "100%" }} >
                        {/* Parlamentar Header */}
                        <ParlamentarConsultaHeader parlamentar={parlamentar} idPermissao={user.id_permissao} />
                        {/* ---------------- BOTOES ---------------------  */}
                        <ParlamentarConsultaBotoes parlamentar={parlamentar} onChange={loadParlamentar} idPermissao={user.id_permissao}
                            consultaStatusProcessamentoIa={intervalStatusProcessamentoIA} />
                        {/* Parlamentar Inicio */}
                        {parlamentar ? <ParlamentarConsultaInicio statusProcessamentoIa={statusProcessamentoIA} parlamentar={parlamentar} idPermissao={user.id_permissao} /> : null}
                        {/* Abas: Perfil | Informações | Menu do Interlocutor */}
                        <ParlamentarConsultaAbas
                            parlamentar={parlamentar}
                            idPermissao={user.id_permissao}
                            id_parlamentar={Number(id)}
                            onChange={loadParlamentar}
                            onBlur={loadParlamentar}
                        />
                    </Paper>
                    <Grid container style={{ paddingTop: "30px" }}>
                        <Grid item style={{ width: "100%" }}>
                            <ParlamentarCarouselTabs
                                id_parlamentar={Number(id)}
                                query={qry} parlamentar={parlamentar}
                                permissaoUsuario={user.id_permissao}
                                twitterUsername={parlamentar?.social?.rede3}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Main>
        </div>
    );
}